import { View, Keyboard } from 'react-native';
import { useState } from 'react';
import AuthPage, { AuthHeader, AuthInput as Input, AuthButton as SolidButton } from '@/components/General/AuthPage';
import Toast from "react-native-toast-message"
import { supabase } from '@/data/client';
import { useRouter } from 'expo-router';


const RecoverAccountScreen = () => {
    const [recoveryEmail, setRecoveryEmail] = useState("");
    const [signingIn, setSigningIn] = useState(false);
    const router = useRouter();

    return (
        <AuthPage showBack>
                    <AuthHeader
                        eyebrow="Account recovery"
                        title="Let's find your account"
                        description="Enter the email address you registered with. We'll send you a code to reset your password."
                    />
                    <View>
                        <Input
                            key="recovery_email"
                            title="Email"
                            autoCapitalize='none'
                            autoComplete="email"
                            autoCorrect={false}
                            type="email"
                            value={recoveryEmail}
                            onUpdate={(new_value) => {
                                setRecoveryEmail(new_value);
                            }}
                        />
                    </View>

            
                    <View style={{marginTop:20}}>
                        <SolidButton processing={signingIn} onPress={async () => {
                            Keyboard.dismiss();
                            setSigningIn(true);

                            const { error } = await supabase.auth.resetPasswordForEmail(recoveryEmail.trim())

                            if(error){
                                Toast.show({type: 'error', text2: error.message})
                                setSigningIn(false);
                                return false;
                            }

                            router.push({pathname: "/auth/account/reset-password", params: {isRecovery: true, recoveryEmail: recoveryEmail}})
                        
                            setSigningIn(false);
                        }} text="Send Recovery Email" size="md"/>
                    </View>
        </AuthPage>
    )
}

export default RecoverAccountScreen